function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
export var DetailedCellError = function DetailedCellError(error, value, address) {
  _classCallCheck(this, DetailedCellError);

  var _a;

  this.value = value;
  this.address = address;
  this.type = error.type;
  this.message = (_a = error.message) !== null && _a !== void 0 ? _a : '';
};